import React from "react";
import PropTypes from "prop-types";

import pluralize from "pluralize";
import { Message } from "semantic-ui-react";
import { formatDate } from "utils";

function SubscriptionScheduledChanges({
  scheduledChanges,
  scheduledChangesAt,
}) {
  if (!scheduledChanges || scheduledChanges.length === 0) {
    return null;
  }

  return (
    <Message data-test="scheduled-changes-information" icon warning>
      <Message.Content>
        <Message.Header data-test="scheduled-changes-header">
          This subscription has{" "}
          {pluralize("scheduled change", scheduledChanges.length, {
            inclusive: true,
          })}{" "}
          that will be applied{" "}
          {scheduledChangesAt
            ? `on ${formatDate("simpleDate")(scheduledChangesAt)}`
            : "upon the next renewal"}
          .
        </Message.Header>
        <ul>
          {scheduledChanges.map((change) => {
            return <li key={change}>{change}</li>;
          })}
        </ul>
      </Message.Content>
    </Message>
  );
}
SubscriptionScheduledChanges.propTypes = {
  scheduledChanges: PropTypes.arrayOf(PropTypes.string),
  scheduledChangesAt: PropTypes.instanceOf(Date),
};

SubscriptionScheduledChanges.defaultProps = {
  scheduledChanges: [],
  scheduledChangesAt: null,
};

export default SubscriptionScheduledChanges;
